import React from 'react';
import { formatPrice } from '@dashboard/services/formatting';
import { useStatisticsContext } from '../Dashboard';
import { formatTimestamp, formatValue } from '../dates';
import { useStatistics } from '../queries';
import { StatHeader, StatMetric, StatTooltip, StatBody, StatChart } from './StatCard';

const formatUSD = amount => formatPrice({ amount, currency: 'USD' });

export default function Revenue() {
  const { unit, range } = useStatisticsContext();
  const { data, isLoading } = useStatistics('revenue');

  const revenueData = data?.map(({ timestamp, value }) => ({
    timestamp: formatTimestamp(timestamp, unit, range),
    Revenue: formatValue(timestamp, value),
  }));

  const totalRevenue = data?.reduce((acc, { value }) => acc + value, 0);
  const maxValue = data && Math.max(...data?.map(({ value }) => value), 0);
  const minValue = data && Math.min(...data?.map(({ value }) => value), 0);

  return (
    <div>
      <StatHeader>
        <StatMetric
          isLoading={isLoading}
          label="Revenue"
          tooltip={
            <StatTooltip>
              Gross revenue from one-time payments and subscriptions before refunds and Stripe fees.
            </StatTooltip>
          }
          value={formatUSD(totalRevenue)}
        />
      </StatHeader>

      <StatBody>
        <StatChart
          isLoading={isLoading}
          data={revenueData}
          categories={['Revenue']}
          maxValue={formatUSD(maxValue)}
          minValue={formatUSD(minValue)}
          valueFormatter={formatUSD}
        />
      </StatBody>
    </div>
  );
}
